import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  SelectLabel,
  SelectGroup,
  cn,
} from "@jana-technology/platform-ui";

import type { SimpleSelectProps } from "./types";

export const SimpleSelect = ({
  id,
  label,
  placeholder = "Select one",
  disabled,
  className,
  triggerClassName,
  labelClassName,
  contentClassName,
  itemClassName,
  items,
  value,
  children,
  onValueChange,
}: SimpleSelectProps) => {
  return (
    <SelectGroup className={className}>
      <Select
        value={value}
        onValueChange={onValueChange}
        disabled={Boolean(disabled)}
      >
        {Boolean(label) && (
          <SelectLabel className={cn("mb-2 font-medium", labelClassName)}>
            {label}
          </SelectLabel>
        )}
        <SelectTrigger className={cn("w-72", triggerClassName)} id={id}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className={contentClassName}>
          {items.map((item) => (
            <SelectItem
              key={item.value}
              value={item.value}
              className={itemClassName}
            >
              {item.children ?? item.label ?? item.value}
            </SelectItem>
          ))}
          {children}
        </SelectContent>
      </Select>
    </SelectGroup>
  );
};
